/**
 * 该文件用来统一处理对element-ui组件的引入
 * */
import Vue from 'vue';
import {
  Carousel,
  CarouselItem,
  Table,
  TableColumn,
  Pagination,
  Input,
  Form,
  FormItem,
  Select,
  Option,
  Button,
  Row,
  Col,
  Radio,
  RadioButton,
  RadioGroup,
  Checkbox,
  InputNumber,
  Divider,
  Card,
  Image,
  Avatar,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Dialog,
  DatePicker,
  Collapse,
  CollapseItem,
  Popover,
  Switch,
  Upload,
  Loading,
  Message,
  Notification,
  MessageBox,
} from 'element-ui';

const elementComponents = {
  Carousel,
  CarouselItem,
  Table,
  TableColumn,
  Pagination,
  Input,
  Form,
  FormItem,
  Button,
  Row,
  Col,
  Radio,
  RadioButton,
  RadioGroup,
  Checkbox,
  InputNumber,
  Divider,
  Card,
  Image,
  Avatar,
  Tooltip,
  Select,
  Option,
  Breadcrumb,
  BreadcrumbItem,
  Dialog,
  DatePicker,
  Collapse,
  CollapseItem,
  Popover,
  Switch,
  Upload,
  Message,
  Notification,
  MessageBox,
};

Object.values(elementComponents).forEach(value => Vue.component(value.name, value));

Vue.use(Loading.directive);

Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
